import script from "./KioskCheckoutBar.vue?vue&type=script&setup=true&lang=js"
export * from "./KioskCheckoutBar.vue?vue&type=script&setup=true&lang=js"

import "./KioskCheckoutBar.vue?vue&type=style&index=0&id=6138c786&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6138c786"]])

export default __exports__